import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {api} from '../api/index'

function getToken(vtg_id, func) {

  // 현재 URL의 파라미터 가져오기
  const urlParams2 = new URLSearchParams(window.location.search);

  // const url = new URL(location.href);
  // const connInfo2 = url.searchParams.get('connInfo');


  // 'connInfo' 파라미터의 값을 가져오기
  let connInfo    = decodeURIComponent( urlParams2.get('connInfo') );
  connInfo = connInfo.replaceAll(' ','+');

  // alert( 'connInfo [' + connInfo + ']' );
  // alert( 'connInfo2 [' + connInfo2 + ']' );
  // alert( 'location [' + location.href + ']' );
  const user_vtgID  = decodeURIComponent( urlParams2.get('vtg_id') );
  const user_phone  = decodeURIComponent( urlParams2.get('phone') );
  // console.log( connInfo );
  if( user_vtgID ){ Vue.$cookies.set("user_vtgID", {val: user_vtgID }, null,null, location.hostname); }
  if( user_phone ){ Vue.$cookies.set("user_phone", {val: user_phone }, null,null, location.hostname); }

  axios.post(`${api.users}/storeToken`, { vtg_id: vtg_id , connInfo: connInfo })
  .then((res) => {

    // console.log(res);return;
    if (res.data.token == false) {
      logOut();
      if(func) func(vtg_id);
    } else {
      let user_scp = res.data.user;
      if (user_scp) {
        store.commit("setUserScp", {
          id: user_scp.id,
          email: user_scp.email,
          name: user_scp.name,
          vtg_id: user_scp.vtg_id,
          vtg_no: user_scp.vtg_no,
          mobile: user_scp.mobile,
          ci: user_scp.ci,
        });
      }
      login(res.data);
      if(func) func(vtg_id);
    }
    // console.log( 'userData:' + JSON.stringify( res.data.user ) );
  })
  .catch(() => {
    if(func) func(vtg_id);
  })


}

function login(data) {
  Vue.$cookies.set("app_token", {token: data.token, user: data.user}, data.expires_in,null, location.hostname);
  axios.defaults.headers.common['Authorization'] = `Bearer ${Vue.$cookies.get("app_token").token}`;
}

function logOut() {
  if(Vue.$cookies.isKey('app_token'))
    Vue.$cookies.remove('app_token',null, location.hostname)
  axios.defaults.headers.common['Authorization'] = null;
}

function refreshToken(originalRequest) {
  return axios.post(`${api.users}/updateToken`, { axiosDate: (Vue.$cookies.isKey('app_axiosDate')) ? Vue.$cookies.get('app_axiosDate') : null })
  .then((res) => {
    login(res.data);
    originalRequest.headers['Authorization'] = 'Bearer ' + res.data.token // new header new token
    return axios(originalRequest) // retry the request that errored out
  })
  .catch((err) => {
    store.commit('setUser',{});
    err.status= 401;
    err.response.status = 401;
    err.response.statusText = '사용자 없음';
    return Promise.reject(err);
  })
}


function removeToken() {
  axios.delete(`${api.users}/destroyToken`)
    .then(() => {
      alert('로그아웃 됐습니다.')
      logOut();
    })
    .catch((err) => {
      console.log(err)
      logOut();
    })
}

export {
  getToken,
  refreshToken,
  removeToken,
}